import { CiUser } from 'react-icons/ci';
import { GoGear } from 'react-icons/go';
import { PiCoinsLight } from 'react-icons/pi';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import './footer.styles.scss';

const Footer = () => {

    const userCredit = useSelector((state) => state.user.mycredits);

    return (
      <footer className="container-fluid pb-4 pb-sm-2 mb-4 mb-sm-0">
        <div className="row">
          <div className="col-12 col-md-6 order-md-12 text-center text-md-right">
            <p className="m-0 text-uppercase">
              Design &amp; Developed by <span>Janszen Media</span>
            </p>
          </div>
          <div className="col-12 col-md-6 order-md-1 text-center text-md-left">
            <p className="m-0 text-uppercase">&copy; 3For3 Networking</p>
          </div>
        </div>

        <div className="d-block d-sm-none fixed-bottom navbar p-0 text-white footer-fix-menu">
          <div className="row">
            <div className="col border px-0">
              <NavLink
                to="/my-profile"
                className="text-white"
                activeClassName="active"
              >
                <div className="footer-menu-item d-flex justify-content-center align-items-center py-2 pl-2">
                  <CiUser size={24} className="mr-2" />
                  <b className="text-center" style={{ fontSize: 12 }}>
                    My Profile
                  </b>
                </div>
              </NavLink>
            </div>
            <div className="col border px-0">
              <NavLink
                to="/manage-preferences"
                className="text-white"
                activeClassName="active"
              >
                <div className="footer-menu-item d-flex justify-content-center align-items-center py-2">
                  <GoGear size={24} className="mr-2" />
                  <b className="text-center" style={{ fontSize: 12 }}>
                    Preferences
                  </b>
                </div>
              </NavLink>
            </div>
            <div className="col border px-0">
              <NavLink
                to="/billing"
                className="text-white"
                activeClassName="active"
              >
                <div className="footer-menu-item d-flex justify-content-center align-items-center py-2 pr-2">
                  <PiCoinsLight size={24} className="mr-2" />
                  <b className="text-center" style={{ fontSize: 12 }}>
                    {userCredit} Credits
                  </b>
                </div>
              </NavLink>
            </div>
          </div>
        </div>
      </footer>
    );
}

export default Footer;